<p>Välj vilka kostnadsställen du vill ha notifieringar för.</p>
<ul class="cost-centers">
  <li class="item" *ngFor="let item of items" (click)="select(item)" [ngClass]="{'green': item.selected, 'blue': !item.selected}"><input type="checkbox" [checked]="item.selected" /><label>Kostnadsställe XYZ</label></li>
</ul>
